import axios from "axios";
import { User } from "./User";

/**Perform a POST operation on the API Gateway to place the user information in the database.
 * @param {User} userParams - The User object to be passed to the database. It will be converted to a JSON string in the process.
*/
export const putItem = async (userParams: User) => {
    const baseURL = process.env.REACT_APP_BASE_URL ?? "";
    if (baseURL.length < 1) {
        console.log("No valid URL.");
        return;
    }
    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };
   const response = await axios.post(baseURL, JSON.stringify(userParams), config);
   return response;
};